/* ==========================================================================
   Cybercraft - model generation console (1g), v2.

   PAY FIRST. hi3D bills the moment a task is created, so nothing is generated
   until Shopify confirms payment. This file therefore does no generating at
   all - it collects photos and settings, prices the basket, and hands the lot
   to Shopify's cart.

   ONE PHOTO = ONE MODEL = ONE CART LINE.
   Several photos are separate subjects, not several angles of one. Shopify
   keeps lines apart when their properties differ, so each photo gets its own
   line carrying its own image.

   Photos travel as a Shopify line item property file upload - verified
   working 2026-08-16, no app required, 20 MB cap per file.

   Config arrives on the root element's data attributes; tiers arrive as JSON
   in a script tag, so prices and variant IDs stay editable in the theme
   editor rather than being frozen in here.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-ccg-root]');
  if (!root) return;

  var $  = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var cfg   = JSON.parse($('[data-ccg-config]').textContent);
  var tiers = cfg.tiers || [];
  var CUR   = cfg.currency || 'S$';
  var MAXMB = parseFloat(cfg.maxMb) || 20;
  var MAXB  = MAXMB * 1024 * 1024;
  var MAXP  = parseInt(cfg.maxPhotos, 10) || 10;
  var OK    = ['image/jpeg', 'image/png', 'image/webp'];

  var photos = [];
  var busy   = false;

  function money(n) { return CUR + n.toFixed(2); }
  function tier()   { var el = root.querySelector('input[name="ccg-detail"]:checked');
                      return el ? tiers[parseInt(el.value, 10)] : tiers[0]; }
  function versions(){ var r = $('[data-ccg-versions]'); return r ? parseInt(r.value, 10) : 1; }

  /* Price per photo. High adds a flat extra per additional version; the first
     is included, which is what makes the S$1.50 promo code land exactly. */
  function unitPrice() {
    var t = tier();
    if (!t) return 0;
    var p = parseFloat(t.price);
    if (t.allowVersions) p += (versions() - 1) * parseFloat(t.extra || 0);
    return p;
  }

  function variantId() {
    var t = tier();
    if (!t) return null;
    return t.allowVersions ? t.variantIds[versions() - 1] : t.variantIds[0];
  }

  /* ---- rejection feedback ------------------------------------------------
     A file that silently vanishes on drop reads as a broken page, so every
     rejection is named with its reason. */
  function showRejects(list) {
    var box = $('[data-ccg-reject]');
    box.innerHTML = '';
    if (!list.length) { box.hidden = true; return; }
    box.hidden = false;
    var h = document.createElement('strong');
    h.textContent = list.length === 1 ? '1 file was not accepted'
                                      : list.length + ' files were not accepted';
    box.appendChild(h);
    list.forEach(function (r) {
      var s = document.createElement('span');
      s.className = 'ccg-reject__item';
      s.textContent = r.name + ' — ' + r.reason;
      box.appendChild(s);
    });
  }

  /* ---- photo grid -------------------------------------------------------- */
  function renderPhotos() {
    var grid = $('[data-ccg-shots]');
    grid.innerHTML = '';

    photos.forEach(function (f, i) {
      var cell = document.createElement('div');
      cell.className = 'ccg-shot';

      var img = document.createElement('img');
      img.alt = '';
      img.src = URL.createObjectURL(f);
      img.onload = function () { URL.revokeObjectURL(img.src); };

      var n = document.createElement('span');
      n.className = 'ccg-shot__n';
      n.textContent = 'MODEL ' + (i + 1);

      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'ccg-shot__x';
      x.setAttribute('aria-label', 'Remove photo ' + (i + 1));
      x.innerHTML = '&times;';
      x.addEventListener('click', function () {
        photos.splice(i, 1); renderPhotos(); render();
      });

      cell.appendChild(img); cell.appendChild(n); cell.appendChild(x);
      grid.appendChild(cell);
    });

    $('[data-ccg-shotwrap]').hidden = photos.length === 0;
    $('[data-ccg-shotcount]').textContent = photos.length;
  }

  function addFiles(list) {
    var rejects = [];
    Array.prototype.forEach.call(list, function (f) {
      if (photos.length >= MAXP) {
        rejects.push({ name: f.name, reason: 'limit is ' + MAXP + ' photos per order' });
      } else if (OK.indexOf(f.type) === -1) {
        rejects.push({ name: f.name, reason: 'JPG, PNG or WEBP only' });
      } else if (f.size > MAXB) {
        rejects.push({ name: f.name, reason: (f.size / 1048576).toFixed(1) + ' MB — limit is ' + MAXMB + ' MB' });
      } else {
        photos.push(f);
      }
    });
    showRejects(rejects);
    renderPhotos();
    render();
  }

  /* ---- summary ----------------------------------------------------------- */
  function render() {
    var t = tier();
    var n = photos.length;
    var unit = unitPrice();

    /* The versions control is meaningless for Standard, which returns exactly
       one file. Hiding it beats disabling it - a greyed-out slider invites
       the question "why can't I?" */
    var vWrap = $('[data-ccg-versionwrap]');
    if (vWrap) vWrap.hidden = !(t && t.allowVersions);

    $$('[data-ccg-tierhint]').forEach(function (el) {
      el.textContent = t ? (t.hint || '') : '';
    });

    $('[data-ccg-sumtier]').textContent = t ? t.name + ' · ' + money(unit) + ' each' : '—';
    $('[data-ccg-sumcount]').textContent = n === 0 ? '—'
      : n + (n === 1 ? ' photo' : ' photos') + ' · ' + n + (n === 1 ? ' model' : ' models');

    var calc = $('[data-ccg-sumcalc]');
    if (n > 1) { calc.hidden = false; calc.querySelector('b').textContent = n + ' × ' + money(unit); }
    else { calc.hidden = true; }

    if (t && t.allowVersions) {
      var v = versions();
      $('[data-ccg-versionval]').textContent = v;
      $('[data-ccg-sumversions]').closest('.ccq-sum__row').hidden = false;
      $('[data-ccg-sumversions]').textContent = v + (v === 1 ? ' version' : ' versions') + ' each';
    } else if ($('[data-ccg-sumversions]')) {
      $('[data-ccg-sumversions]').closest('.ccq-sum__row').hidden = true;
    }

    $('[data-ccg-sumturn]').textContent = t ? t.turnaround : '—';
    $('[data-ccg-turnnote]').innerHTML = t ? t.turnaroundNote : '';
    $('[data-ccg-total]').textContent = n ? money(unit * n) : '—';

    var cta = $('[data-ccg-go]');
    cta.disabled = n === 0 || busy || !variantId();
    $('[data-ccg-golabel]').textContent = busy ? 'Working…'
      : n === 0 ? (cfg.ctaLabel || 'Continue')
                : (cfg.ctaLabel || 'Continue') + ' — ' + money(unit * n);
  }

  /* ---- checkout ----------------------------------------------------------
     Added one at a time rather than via an items[] array: file uploads inside
     that array are unproven, and sequential posting only needs the single-file
     case, which is verified. Slower by a few hundred ms, and reliable. */
  function checkout() {
    if (busy || !photos.length) return;
    var id = variantId();
    if (!id) return;

    busy = true;
    root.classList.add('ccg-busy');
    render();

    var t = tier();
    var chain = Promise.resolve();

    photos.forEach(function (file, i) {
      chain = chain.then(function () {
        var fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', '1');
        fd.append('properties[Detail level]', t.name);
        if (t.allowVersions) fd.append('properties[Versions]', String(versions()));
        fd.append('properties[Model]', (i + 1) + ' of ' + photos.length);
        fd.append('properties[Photo]', file);
        return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) {
            throw new Error(j.description || j.message || 'Could not add photo ' + (i + 1));
          });
        });
      });
    });

    chain.then(function () {
      window.location.href = '/checkout';
    }).catch(function (err) {
      busy = false;
      root.classList.remove('ccg-busy');
      showRejects([{ name: 'Checkout', reason: err.message }]);
      render();
    });
  }

  /* ---- wiring ------------------------------------------------------------ */
  var drop  = $('[data-ccg-drop]');
  var input = $('[data-ccg-input]');

  ['dragenter', 'dragover'].forEach(function (e) {
    drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.add('is-over'); });
  });
  ['dragleave', 'drop'].forEach(function (e) {
    drop.addEventListener(e, function () { drop.classList.remove('is-over'); });
  });
  drop.addEventListener('drop', function (ev) {
    ev.preventDefault();
    if (ev.dataTransfer.files.length) addFiles(ev.dataTransfer.files);
  });
  input.addEventListener('change', function () {
    if (input.files.length) addFiles(input.files);
    input.value = '';
  });

  var clear = $('[data-ccg-clear]');
  if (clear) clear.addEventListener('click', function () {
    photos = []; showRejects([]); renderPhotos(); render();
  });

  root.addEventListener('change', function (e) {
    if (e.target.name === 'ccg-detail') render();
  });
  root.addEventListener('input', function (e) {
    if (e.target.hasAttribute('data-ccg-versions')) render();
  });
  root.addEventListener('click', function (e) {
    var step = e.target.closest('[data-ccg-step]');
    if (!step) return;
    var r = $('[data-ccg-versions]');
    r.value = Math.max(+r.min, Math.min(+r.max, +r.value + parseInt(step.dataset.ccgStep, 10)));
    render();
  });

  $('[data-ccg-go]').addEventListener('click', checkout);

  renderPhotos();
  render();
})();
